import { render, staticRenderFns } from "./SectionItemSlider.vue?vue&type=template&id=32283429&scoped=true&lang=pug&"
import script from "./SectionItemSlider.vue?vue&type=script&lang=js&"
export * from "./SectionItemSlider.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemSlider.vue?vue&type=style&index=0&id=32283429&scoped=true&lang=scss&"
import style1 from "./SectionItemSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32283429",
  null
  
)

export default component.exports